var React = require('react');

function TriangleContactCS (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M89.9231 91.4296L82.0936 25.9622L172.289 73.792L89.9231 91.4296Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M34.3325 133.496L82.1876 25.8886L89.975 91.281L34.3325 133.496Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M34.3359 133.495L89.9393 91.3103L172.292 73.7895L34.3359 133.495Z","fill":"#5915C7","key":2})]);
}

TriangleContactCS.defaultProps = {"width":"173","height":"163","viewBox":"0 0 173 163","fill":"none"};

module.exports = TriangleContactCS;

TriangleContactCS.default = TriangleContactCS;
